/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import * as Yup from 'yup';
// import moment from 'moment';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { appRoutes, routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import OtherSecondary from './components/OtherSecondary';
import CounselorInformation from './components/CounselorInformation';
import GraduatingSchool from './components/GraduatingSchool';
import {
  hasOtherGradingScaleSelected,
  syncTextWithOtherGradingSchools,
} from './components/education.config';
import { getHighSchool, updateHighSchool } from 'app/highSchoolSlice/highSchoolSlice';
import { checkEnableParseJSON, migrateGraduatingClassSize, reorder } from 'components/helper/helper';
import TextAreaInput from 'components/input/TextAreaInput';
import { debounce } from 'lodash';
import { identifyUserpilot } from 'utils/userpilotClient';
import SelectInput from 'components/input/SelectInput';
import { displayHighSchoolName } from './highSchoolSearch';
import { scrollToCenterObject } from 'components/helper/ui_helper';
import Grid from '@mui/joy/Grid';
import { ModalCheckEducationFields } from 'screen/education/common/ModalCheckMissingFields';
import SearchIcon from '@mui/icons-material/Search';
import pageStatusService from 'services/pageStatusService';
import { PAGE_NAME } from 'constants/common';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';

interface Props {}

// UC application limit for "Additional comments" (high_school_info.academic_history).
const UC_ADDITIONAL_COMMENTS_MAX_CHARS = 550;

const HighSchool = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [showMissingFieldsModal, setShowMissingFieldsModal] = React.useState(false);
  const dispatch:any = useAppDispatch();
  const location:any = useLocation();
  const history:any = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const [otherSchoolData, setOtherSchoolData] = React.useState<any[]>([{}]);
  const [highSchoolData, setHighSchoolData] = React.useState<any[]>([{}]);
  const information:any = useAppSelector((store:any) => store.basicInformation.myBasicInformation);
  const role = information?.user_role ?? '';
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');
  const indexExpand = query.get('index');
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const studentAdditionalInfo:any = useAppSelector((store:any) => store.authorization.studentAdditionalInfo);

   
  const graduationSchoolSchema = Yup.object().shape({
    // graduating_date_received: Yup.string().nullable().required('This field is required')
    //     .when('graduation_status', {
    //       is: (e:any) => e === 'I have or will graduate with my high school diploma',
    //       then: Yup.string().nullable()
    //       .test(
    //         'is-valid-date',
    //         'Invalid date',
    //         function (value:any) {
    //           if (!value) {
    //             return false;
    //           }
    
    //           // let year = moment(value).format('yyyy');
    //           // if (Number(year)<MIN_YEAR) return false;
    
    //           return moment(value).isValid();
    //         }
    //       ),
    // }),
    change_in_progression_through_highschool: Yup.string().nullable().required('This field is required')
    .when(['progression_is_graduate_early',
           'progression_is_graduate_late',
           'progression_is_time_off',
           'progression_is_take_gap_year'], {
      is: (progression_is_graduate_early:any, 
           progression_is_graduate_late:any,
           progression_is_time_off:any, 
           progression_is_take_gap_year:any
       ) => (progression_is_graduate_early || progression_is_graduate_late ||
             progression_is_time_off || progression_is_take_gap_year),
      then: Yup.string().required('This field is required'),
      otherwise: (schema) => schema.notRequired()
    }),
    graduating_high_school: Yup.string().nullable()
      .when('graduating_school_rank_report', {
        is: (e:any) => e === 'I have or will graduate with my high school diploma',
        then: Yup.string().required('This field is required')
      }),

    graduating_school_year: Yup.string().nullable().required('This field is required'),
    graduating_school_gpa_type: Yup.string().nullable().required('This field is required'),
    graduating_school_gpa_scale: Yup.string().nullable().required('This field is required'),
    graduating_school_cumulative_gpa: Yup.string().nullable().required('This field is required'),

    class_rank: Yup.number()
      .when('graduation_status', {
        is: (e:any) => e === 'Exact',
        then: Yup.number()
          .typeError('Class rank must be a number') 
          .required('This field is required')
      }),
    decile_rank: Yup.string()
      .when('graduating_school_rank_report', {
        is: (e:any) => e === 'Decile',
        then: Yup.string().required('This field is required')
      }),
    quintile_rank: Yup.string()
      .when('graduating_school_rank_report', {
        is: (e:any) => e === 'Quintile',
        then: Yup.string().required('This field is required')
      }),
    quartile_rank: Yup.string()
      .when('graduating_school_rank_report', {
        is: (e:any) => e === 'Quartile',
        then: Yup.string().required('This field is required')
      }),

    rank_weighting: Yup.string().required('This field is required'),
    graduating_class_size: Yup.string().required('This field is required'),

  });
  
  const formikGraduatingSchool = useFormik({
    initialValues: {
      graduating_date_received: '',
      graduation_status: '',
      graduating_high_school: '',
      graduating_school_year: '',
      graduating_school_gpa_type: 'Weighted',
      graduating_school_gpa_scale: '',
      graduating_school_cumulative_gpa: '',
      graduating_school_rank_report: '',
      graduating_class_size: 0,
      class_rank_reporting: 'Exact',
      class_rank: 0,
      decile_rank: '',                        // added 2025-10-10
      quintile_rank: '',                      // added 2025-10-10
      quartile_rank: '',                      // added 2025-10-10
      gpa_scale_reporting: '',
      culmative_gpa: '',
      gpa_weighting: 'Weighted',
      gpa_scale_other: '',
      rank_weighting: '',
      progression_is_graduate_early: false,
      progression_is_graduate_late: false,
      progression_is_time_off: false,
      progression_is_take_gap_year: false,
      progression_is_no_change: false,
    },
    validationSchema: graduationSchoolSchema,
    onSubmit: () => {},
  });

  const validationSchema = Yup.object().shape({
    high_school_info: Yup.object({
      academic_history: Yup.string().nullable(),
    }),

    counselor_first_name: Yup.string().nullable(),
    counselor_last_name: Yup.string().nullable(),
  });

  // const validatefunc = async (values:any) => {
  //   const errors: any = {};
   
  //   // Validate basic schema for other fields
  //   try {
  //     if (!loading)
  //     validationSchema.validateSync(values, { abortEarly: false });
  //   } 
  //   catch (error: any) {
  //     console.log('error:', error);
  //     if (error.inner) {
  //       error.inner.forEach((err: any) => {
  //         const path = err.path;
  //         if (path) {
  //           const keys = path.split('.');
  //           let current = errors;
  //           for (let i = 0; i < keys.length - 1; i++) {
  //             if (!current[keys[i]]) current[keys[i]] = {};
  //             current = current[keys[i]];
  //           }
  //           current[keys[keys.length - 1]] = err.message;
  //         }
  //       });
  //     }
  //   }

  //   await formikGraduatingSchool.validateForm();
    
  //   if (!formikGraduatingSchool.isValid) {
  //     // combine formikGraduatingSchool.errors to formik.errors
  //     Object.keys(formikGraduatingSchool.errors).forEach(key => {
  //       let obj:any = formikGraduatingSchool.errors;
  //       let current = errors;
  //       current[key] = `${obj[key]}`;
  //     });
  //   }
  //   console.log('errors:', errors);

  //   return errors;

  // }

  const formik = useFormik({
    initialValues: {
      high_school_info: {
        where_attend_high_school: '',
        state: '',
        city: '',
        country: '',
        is_home_school: false,
        is_independant_study: false,
        my_home_school_associated_with_high_school: false,
        school_name: '',
        school_type: '',
        left_highschool_reason: '',
        academic_history: '',
      },
      high_school_array: '',
      number_of_other_school_attended: '0',
      other_school_array: '',
      graduating_school_array: '',
      counselor_prefix: '',
      counselor_first_name: '',
      counselor_middle_initial: '',
      counselor_last_name: '',
      counselor_job_title: '',
      counselor_email: '',
      counselor_country_code: '',
      counselor_phone_number: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values, submitProps) => {
      try {
        studentId = getUserId();
        token = getAccessToken();
        if (token && studentId && information) {
          setSaving(true);
          const newValues = {
            ...values,
            student_id: studentId,
            high_school_array: JSON.stringify(highSchoolData),
            other_school_array: JSON.stringify(otherSchoolData),
            graduating_school_array: JSON.stringify(
              migrateGraduatingClassSize(formikGraduatingSchool.values)
            ),
            high_school_info: JSON.stringify(values.high_school_info),
          };
          identifyUserpilot(studentId, role, {
            name: information?.first_name,
            email: information?.email,
            created_at: information?.created_at,
            highSchool: highSchoolData.map((item) => item.high_school_name).join(', '),
            termType: highSchoolData.map((item) => item.classes_schedule).join(', '),
          });
          await dispatch(updateHighSchool(newValues));
          submitProps.resetForm({ values });
          setSaving(false);
        } else {
          handleLogout();
        }
      } catch (ex) {
        setSaving(false);
        console.log('Error:', ex);
      }
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = async () => {
    await formik.submitForm();
    history.push(appRoutes.collegeAndUniversity.path);
  };

  const handleCheckMissingFields = () => {
    setShowMissingFieldsModal(true);
  };


  const AutoScrollAndExpand = () => {
    try {
      const hash = location.hash.slice(1); // Remove the '#' character from the hash
      if (hash) {
        let ele: any = document.getElementById(hash);
        if (ele && hash === 'AddHighSchool') {
          setTimeout(() => {
            scrollToCenterObject(hash);
          }, 1800);
        }

        if (hash.includes('AddTermYear')) {
          let itemIndex = Number(hash.replaceAll('AddTermYear', '') ?? '-1') ?? 0;
          setTimeout(() => {
            document.getElementById(`cardItem${itemIndex}`)?.click();
            setTimeout(() => {
              scrollToCenterObject(hash);
            }, 1800);
          }, 2000);
        } else if (hash.includes('cardItem')) {
          let itemIndex = Number(hash.replaceAll('cardItem', '') ?? '-1') ?? 0;
          setTimeout(() => {
            document.getElementById(hash)?.click();
            setTimeout(() => {
              scrollToCenterObject(`high_school_name${itemIndex}`);
            }, 1800);
          }, 1800);
        } else if (hash.includes('start_date')) {
          let itemIndex = Number(hash.replaceAll('start_date', '') ?? '-1') ?? 0;
          setTimeout(() => {
            document.getElementById(`cardItem${itemIndex}`)?.click();
            setTimeout(() => {
              scrollToCenterObject(hash);
            }, 1800);
          }, 2000);
        } else if (hash.includes('end_date')) {
          let itemIndex = Number(hash.replaceAll('end_date', '') ?? '-1') ?? 0;
          setTimeout(() => {
            document.getElementById(`cardItem${itemIndex}`)?.click();
            setTimeout(() => {
              scrollToCenterObject(hash);
            }, 1800);
          }, 2000);
        } else if (hash.includes('grade')) {
          let str = hash.replaceAll('grade', '');
          let idx = str.indexOf('_');
          let s1 = str.substring(0, idx);
          let itemIndex = Number(s1);

          setTimeout(() => {
            document.getElementById(`cardItem${itemIndex}`)?.click();
            setTimeout(() => {
              scrollToCenterObject(hash);
            }, 1800);
          }, 2000);
        } else if (hash.includes('academic_year')) {
          let str = hash.replaceAll('academic_year', '');
          let idx = str.indexOf('_');
          let s1 = str.substring(0, idx);
          let itemIndex = Number(s1);

          setTimeout(() => {
            document.getElementById(`cardItem${itemIndex}`)?.click();
            setTimeout(() => {
              scrollToCenterObject(hash);
            }, 1800);
          }, 2000);
        } else if (hash.includes('remove_term')) {
          let str = hash.replaceAll('remove_term', '');
          let idx = str.indexOf('_');
          let s1 = str.substring(0, idx);
          let itemIndex = Number(s1);

          setTimeout(() => {
            document.getElementById(`cardItem${itemIndex}`)?.click();
            setTimeout(() => {
              scrollToCenterObject(hash);
            }, 1800);
          }, 2000);
        }
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
  };

  const notInitialRender = React.useRef(false);

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.HIGH_SCHOOL);
      if(pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }
      const res = await dispatch(getHighSchool(studentId));
      if (res?.payload) {
        formik.resetForm({
          values: {
            ...formik.values,
            ...res.payload,
            high_school_info: {
              ...formik.values.high_school_info,
              ...checkEnableParseJSON(res.payload.high_school_info),
            },
          },
        });


        // Graduation Status form:
        formikGraduatingSchool.resetForm({
          values: migrateGraduatingClassSize({
            ...formikGraduatingSchool.values,
            ...(checkEnableParseJSON(res.payload.graduating_school_array) || {}),
          }),
        });
        setHighSchoolData(checkEnableParseJSON(res.payload.high_school_array, []));
        setOtherSchoolData(checkEnableParseJSON(res.payload.other_school_array, []) || []);
      }
      AutoScrollAndExpand();
      setLoading(false);
      formik.setStatus('idle');
      notInitialRender.current = true;
    } else {
      handleLogout();
    }
  };
  React.useEffect(() => {
    getDetail();
    AutoScrollAndExpand();
    ///formik.va = validatefunc();
  }, []);

  React.useEffect(() => {
    AutoScrollAndExpand();
  }, [location]);

  const mergeSchoolsForOtherGradingSync = React.useCallback((schools: any[], arrayJson?: string) => {
    const fromFormik = checkEnableParseJSON(arrayJson, []) ?? [];
    const maxLength = Math.max(schools?.length ?? 0, fromFormik.length);

    return Array.from({ length: maxLength }, (_, index) => {
      const school = schools?.[index] ?? {};
      const fromArray = fromFormik[index] ?? {};

      return {
        ...school,
        ...fromArray,
        grading_scale_is_other:
          hasOtherGradingScaleSelected(school) || hasOtherGradingScaleSelected(fromArray),
        other_grading_system: fromArray.other_grading_system ?? school.other_grading_system,
        high_school_name: fromArray.high_school_name ?? school.high_school_name,
      };
    });
  }, []);

  React.useEffect(() => {
    if (!notInitialRender.current) {
      return;
    }

    const schoolsForSync = mergeSchoolsForOtherGradingSync(
      highSchoolData,
      formik.values.high_school_array
    );

    const syncField = (fieldName: 'academic_history' | 'left_highschool_reason') => {
      const currentValue = formik.values.high_school_info?.[fieldName] ?? '';
      const nextValue = syncTextWithOtherGradingSchools(currentValue, schoolsForSync);

      if (nextValue !== currentValue) {
        formik.setFieldValue(`high_school_info.${fieldName}`, nextValue, true);
      }
    };

    syncField('academic_history');

    if (schoolsForSync.length > 1) {
      syncField('left_highschool_reason');
    }
  }, [highSchoolData, formik.values.high_school_array, mergeSchoolsForOtherGradingSync]);

  // Auto save function ==========
  React.useEffect(() => {
    (formik.dirty || formikGraduatingSchool.dirty) && debounceSaving();
  }, [formik.values, formikGraduatingSchool.values, highSchoolData, studentAdditionalInfo]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (notInitialRender.current) formik.handleSubmit();
    }, 1500),
    []
  );

  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Auto save function ==========
  const handleInvite = () => {
    try {
      if (!saving) {
        if (formik.dirty) formik.handleSubmit(); // save info before redirect
        setTimeout(() => {
          let path = `${routers.settings.path}?active-tab=3#invite_couselor`;
          history.push(path);
        }, 1500);
      }
    } catch (ex) {
      console.log('Error: ', ex);
    }
  };

  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.HIGH_SCHOOL, reviewedAndComplete, setReviewedAndComplete);
  }

  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { title: 'General', percentOnProcess: 20 },
          { title: 'Graduation', percentOnProcess: 40 },
          { title: 'Other High Schools', percentOnProcess: 55 },
          { title: 'Graduating School', percentOnProcess: 70 },
          { title: 'H.S. Counselor', percentOnProcess: 85, specialId: 'HSCounselor' },
        ]}
        title="Education"
        process={1}
        icon={<StickyNote2OutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`} id="General">
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            name="high_school_form"
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                High Schools
              </span>
            </div>
            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Graduation">
                    Let's get all your educational information in one place!
                  </div>
                </Grid>

                <Grid xs={12}>
                  <SelectInput
                    disabled={reviewedAndComplete}
                    label="Current or Most Recent High School"
                    name="mostHighSchool"
                    dataUp="hs-current-school"
                    values={highSchoolData?.[0]?.high_school_name}
                    option={(highSchoolData ?? []).map((school) => ({
                      id: school.high_school_name,
                      name: displayHighSchoolName(school) || school.high_school_name,
                    }))}
                    onChange={(e) => {
                      try {
                        if (e.target.value) {
                          const index = (highSchoolData ?? []).findIndex(
                            (school) => school.high_school_name === e.target.value
                          );
                          const dataList = reorder(highSchoolData, index, 0);
                          setHighSchoolData([...dataList]);
                          // Mark formik as dirty to trigger autosave
                          formik.setFieldValue('high_school_array', JSON.stringify(dataList), true);
                        }
                      } catch (ex) {
                        console.log('Error:', ex);
                      }
                    }}
                    mdCol="12"
                  />
                </Grid>
              </Grid>
            </div>
            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <OtherSecondary
                    formik={formik}
                    setOtherSchoolData={setHighSchoolData}
                    otherSchoolData={highSchoolData}
                    setLoading={setLoading}
                    check={check}
                    indexExpand={indexExpand}
                    isMobile={isMobile}
                    disabled={reviewedAndComplete}
                  />
                </Grid>
              </Grid>
            </div>
            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div className="text-dart fs-5 p-1 mt-3">Academic Details/Comments</div>
                </Grid>

                <>
                  {highSchoolData.length > 1 && (
                    <Grid xs={12}>
                      <TextAreaInput
                        disabled={reviewedAndComplete}
                        mdCol={'12'}
                        label="Why you left each secondary/high school*"
                        name="high_school_info.left_highschool_reason"
                        dataUp="hs-left-school-reason"
                        isCMLogo={true}
                        countWord={250}
                        isOverCount={true}
                        values={formik.values.high_school_info?.left_highschool_reason}
                        onChange={formik.handleChange}
                        logo="span-cm-logo"
                        isMissing={!formik.values.high_school_info?.left_highschool_reason}
                      />
                    </Grid>
                  )}
                  <Grid xs={12}>
                    <div className="text-dark" style={{ fontSize: '1rem', color: '#4E5A6F' }}>
                      <div className="mb-1">
                        If there's anything else you want us to know about your academic history,
                        you can do so in the space below. But remember, you should use this space
                        only if you want to describe anything that you have not had the opportunity
                        to include elsewhere in this section (for example: a break in attendance,
                        poor grades in a particular course or year, specific information about your
                        school environment or policies that affect your academic record or choices
                        for classes).
                      </div>

                      <div
                        className=""
                        style={{
                          fontSize: '1rem',
                          color: '#4E5A6F',
                          background: (!formik.values.high_school_info?.academic_history && check) ? '#FFEBEB' : '',
                        }}
                      >
                        Why you have missing academic year courses, aka summer courses only, at a
                        specific high school listed above.*
                        <span className="span-uc-logo cm-logo-select-input-float-right"></span>
                      </div>
                    </div>
                  </Grid>

                  <Grid xs={12}>
                    <TextAreaInput
                      id="high_school_info.academic_history"
                      disabled={reviewedAndComplete}
                      mdCol={'12'}
                      name="high_school_info.academic_history"
                      dataUp="hs-academic-history"
                      countText={UC_ADDITIONAL_COMMENTS_MAX_CHARS}
                      isOverCount={true}
                      values={formik.values.high_school_info?.academic_history}
                      onChange={formik.handleChange}
                    />
                  </Grid>
                </>
              </Grid>
            </div>
            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <GraduatingSchool
                    formikGraduatingSchool={formikGraduatingSchool}
                    highSchoolOptions={[...highSchoolData]}
                    check={check}
                    isMobile={isMobile}
                    disabled={reviewedAndComplete}
                  />
                </Grid>
              </Grid>
            </div>
            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <CounselorInformation
                    formik={formik}
                    check={check}
                    saving={saving}
                    handleInvite={handleInvite}
                    isMobile={isMobile}
                    disabled={reviewedAndComplete}
                  />
                </Grid>
              </Grid>
            </div>
            <div className={`gm-form-actions border-top ${isMobile ? 'pt-2 mt-3' : 'pt-3 mt-4'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'}`}>
              {/* Icon + Checkbox combo on the left */}
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-center`}>
                <div className="d-flex flex-column align-items-center">
                  <div
                    onClick={handleCheckMissingFields}
                    className="d-flex align-items-center cursor-pointer mb-2"
                  >
                    <SearchIcon
                      style={{
                        fontSize: '24px',
                        color: '#6c757d',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      check missing values
                    </span>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>

              {/* Save and Continue buttons on the right */}
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <div className="row">
                    {/* <div className="col-md-12 text-right py-4">
                      {!formik.isValid && (
                        <div className='text-danger'>The form is not valid please check for errors.</div>
                      )}
                    </div> */}
                    <div className="col-md-12">
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {saving ? <Spinner size="sm" animation="border" variant="light" /> : 'Save'}
                  </Button>
                  <Button
                    variant="primary"
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                    </div>                
                  </div>

                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
      
      {/* Missing Fields Validation Modal */}
      <ModalCheckEducationFields
        show={showMissingFieldsModal}
        onClose={() => setShowMissingFieldsModal(false)}
        data={{
          myHighSchool: {
            graduating_school_array: migrateGraduatingClassSize(formikGraduatingSchool.values),
            high_school_array: highSchoolData,
            other_school_array: otherSchoolData,
            high_school_info: formik.values.high_school_info,
            counselor_first_name: formik.values.counselor_first_name,
            counselor_last_name: formik.values.counselor_last_name,
          }
        }}
        page="highschool"
      />
    </>
  );
};

export default HighSchool;
